// extracted by mini-css-extract-plugin
module.exports = {"reportsEntry":"styles-module--reportsEntry--30Zk5","entryImage":"styles-module--entryImage--2Yq84","entryBody":"styles-module--entryBody--3c_aJ"};